import { SSEClientManager } from "@/shared/services/SSEClientManager";
import { baseURL, endpoints } from ".";

const equitiesSSEClient = new SSEClientManager({
  endpoint: baseURL + endpoints.streamData,
  connectionName: "Equities-SSE",
});

export default equitiesSSEClient;
